// Typelizer digest 033a3894c0a0cc5da39d1853aadfc971
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/invoices/:invoice_id/credit_notes */
  create: (
    params: { invoiceId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/invoices/:invoice_id/credit_notes', params, options),
    method: 'post',
  }),
}
